import { render } from "./templateLoadGame.vue?vue&type=template&id=1ea665e6"
import script from "./templateLoadGame.vue?vue&type=script&lang=js"
export * from "./templateLoadGame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__